﻿<template>
	<div>
		<input class="ccs-logo-quantity"
				:aria-label="options.quantityText"
				v-model.number="quantity"
				type="number"
				pattern="[0-9]"
				onkeypress="return event.charCode >= 48 && event.charCode <= 57"
				@focus="onFocus"
				@blur="onBlur"/>
	</div>
</template>

<script>
	const qtyGlobalVariablePrefix = "cclpQuantity";
	const initialQty = 1;

	export default {
		props: {
			productId: String
		},

		inject: ["options"],

		data() {
			return {
				quantity: initialQty
			};
		},

		methods: {
			onFocus() {
				if (this.quantity == initialQty) this.quantity = '';
			},

			onBlur() {
				if (this.quantity == '') this.quantity = initialQty
				this.updateQuantity();
			},

			updateQuantity() {
				this.$emit("changed", this.quantity);
				window[qtyGlobalVariablePrefix + this.productId] = this.quantity;
			}
		},

		mounted: function () {
			this.updateQuantity();
		}
	}

</script>

<style scoped>
	.ccs-logo-quantity {
		display: flex;
		align-items: center;
		font-size: 1.4em;
		margin: .3em .6em .3em 0;
		text-align: right;
		width: 2.03em;
	}

	input::-webkit-outer-spin-button,
	input::-webkit-inner-spin-button {
		-webkit-appearance: none;
		margin: 0;
	}
	input[type=number] {
		-moz-appearance: textfield;
		width: 2.03em;
	}
	
	@media screen and (min-width: 320px) and (max-width: 480px) {
		input[type=number] {
			width:1.9em;
			padding:0;
		}
	}

</style>